/**
 * Presentational feature strip shown beneath the live try-on stage on both the
 * in-site /tryon page and the standalone /tryon-studio. Icons are inline SVG so
 * the strip carries no image requests.
 */

import React from 'react';

const TRYON_FEATURES: { title: string; sub: string; icon: React.ReactNode }[] = [
  { title: 'Live Try-On', sub: 'Real time experience', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" /><circle cx="12" cy="13" r="4" /></svg> },
  { title: '1000+ Frames', sub: 'To choose from', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="6" cy="14" r="4" /><circle cx="18" cy="14" r="4" /><line x1="10" y1="13" x2="14" y2="13" /></svg> },
  { title: 'Face Shape', sub: 'Auto-detected', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a9 9 0 0 0-9 9c0 4 3 8 9 11 6-3 9-7 9-11a9 9 0 0 0-9-9z" /></svg> },
  { title: 'Secure & Private', sub: 'Runs on your device', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg> },
  { title: 'Save & Share', sub: 'Snapshot your look', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" /><polyline points="16 6 12 2 8 6" /><line x1="12" y1="2" x2="12" y2="15" /></svg> },
];

const TryonFeatures: React.FC = () => (
  <div className="tryon-features">
    {TRYON_FEATURES.map((f) => (
      <div key={f.title} className="tryon-features__item">
        <span className="tryon-features__icon" aria-hidden>{f.icon}</span>
        <span className="tryon-features__text">
          <span className="tryon-features__title">{f.title}</span>
          <span className="tryon-features__sub">{f.sub}</span>
        </span>
      </div>
    ))}
  </div>
);

export default TryonFeatures;
